import {
  useWindowSize
} from "@/common/hooks/useWindowSize";


export const useIsMobile = () => {
  const isMobile = useWindowSize().innerWidth < 640

  return {
    isMobile,
    isDesktop: !isMobile
  }
}
